"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var authSelectors_1 = require("../selectors/authSelectors");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var deliveryPointState_1 = require("../states/deliveryPointState");
var deliveryPointService_1 = require("../services/deliveryPointService");
var meterIndex_1 = __importDefault(require("../models/meterIndex"));
var utils_1 = require("../helper/utils");
var authState_1 = require("../states/authState");
function downloadProofDocumentEffect(action) {
    var token, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 7]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.downloadProofDocumentService, action.payload, token)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.downloadProofDocumentSuccess(response.pdfContent))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_1 = _a.sent();
                return [4 /*yield*/, handleDownloadProofDocumentFailure(e_1)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, downloadProofDocumentEffect.name))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function handleDownloadProofDocumentFailure(e) {
    var language, errorMsg;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_f.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 500 ||
                    ((_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.status) === 400 ||
                    ((_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.status) === 404 ||
                    ((_d = e === null || e === void 0 ? void 0 : e.response) === null || _d === void 0 ? void 0 : _d.status) === 504)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.downloadInvoiceDocumentsFailure(errorMsg, (_e = e === null || e === void 0 ? void 0 : e.response) === null || _e === void 0 ? void 0 : _e.status))];
            case 2:
                _f.sent();
                return [3 /*break*/, 5];
            case 3:
                if (!(0, utils_1.unauthorizedError)(e)) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 4:
                _f.sent();
                _f.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function downloadProofDocumentForMobileEffect(action) {
    var token, response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 7]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.downloadProofDocumentService, action.payload.sectionSubscriptionId, token, action.payload.origin)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.downloadProofDocumentSuccess(response.pdfContent))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_2 = _a.sent();
                return [4 /*yield*/, handleDownloadProofDocumentFailure(e_2)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, downloadProofDocumentForMobileEffect.name))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function fetchClientWorkOrdersEffect(action) {
    var token, language, data, e_3, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 2:
                language = (_a.sent()).language;
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchClientWorkOrdersService, action.payload, token, language)];
            case 3:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchClientWorkOrderSuccess(data))];
            case 4:
                _a.sent();
                return [3 /*break*/, 12];
            case 5:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).modal.errorMessage;
                if (!(0, utils_1.unauthorizedError)(e_3)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchClientWorkOrderFailure(errorMsg))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchClientWorkOrdersEffect.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function fetchClientWorkOrdersEffectV2(action) {
    var token, language, data, e_4, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 2:
                language = (_a.sent()).language;
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchClientWorkOrdersServiceV2, action.payload, token, language)];
            case 3:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchClientWorkOrderSuccessV2(data))];
            case 4:
                _a.sent();
                return [3 /*break*/, 12];
            case 5:
                e_4 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).modal.errorMessage;
                if (!(0, utils_1.unauthorizedError)(e_4)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchClientWorkOrderFailureV2(errorMsg))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchClientWorkOrdersEffectV2.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function fetchDeliveryPointEffect(action) {
    var token, data, e_5, language, errorDesc, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchDeliveryPointByIdService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchDeliveryPointSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_5 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorDesc = (0, i18n_1.default)(language).modal.errorDesc;
                errorMsg = (0, i18n_1.default)(language).modal.errorMessage;
                if (!(0, utils_1.unauthorizedError)(e_5)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchDeliveryPointFailure(errorMsg, errorDesc))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchDeliveryPointEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchCombinedDeliveryPointEffect(action) {
    var token, data, e_6, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchCombinedDeliveryPointByIdService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchCombinedDeliveryPointSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_6 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).modal.errorMessage;
                if (!(0, utils_1.unauthorizedError)(e_6)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchCombinedDeliveryPointFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchCombinedDeliveryPointEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchdeliveryPointsListEffect(action) {
    var token, data, e_7, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchdeliveryPointsListByProductContractIdService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchdeliveryPointsListSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_7 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).modal.errorMessage;
                if (!(0, utils_1.unauthorizedError)(e_7)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchdeliveryPointsListFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_7, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchdeliveryPointsListEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchLastMeterEffect(action) {
    var token, data, meterIndex, e_8, language, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                if (!token)
                    throw Error('no token provided');
                _b.label = 2;
            case 2:
                _b.trys.push([2, 5, , 14]);
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchLastMeterService, action.payload, token)];
            case 3:
                data = _b.sent();
                meterIndex = new meterIndex_1.default(data);
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchLastMeterIndexSuccess(meterIndex))];
            case 4:
                _b.sent();
                return [3 /*break*/, 14];
            case 5:
                e_8 = _b.sent();
                if (!(((_a = e_8 === null || e_8 === void 0 ? void 0 : e_8.response) === null || _a === void 0 ? void 0 : _a.status) === 404)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchLastMeterIndexSuccess(null))];
            case 6:
                _b.sent();
                return [3 /*break*/, 12];
            case 7: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_8)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchLastMeterIndexFailure(errorMsg))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_8, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchLastMeterEffect.name))];
            case 13:
                _b.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function fetchMeterInfoEffect(action) {
    var token, data, e_9, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchDeliveryPointByIdService, action.payload, token)];
            case 3:
                data = _a.sent();
                if (!(data === null || data === void 0 ? void 0 : data.meter))
                    throw Error('Meter data is missing');
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchMeterInfoSuccess(data === null || data === void 0 ? void 0 : data.meter))];
            case 4:
                _a.sent();
                return [3 /*break*/, 12];
            case 5:
                e_9 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_9)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchMeterInfoFailure(errorMsg))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_9, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchMeterInfoEffect.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function fetchOverConsumptionAlertsEffect(action) {
    var token, data, e_10, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchOverConsumptionAlertsService, action.payload, token)];
            case 3:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchOverConsumptionAlertsSuccess(data))];
            case 4:
                _a.sent();
                return [3 /*break*/, 12];
            case 5:
                e_10 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_10)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchOverConsumptionAlertsFailure(errorMsg))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_10, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchOverConsumptionAlertsEffect.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function catchErrorFetchAlerts(language, e) {
    var errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e)) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 1:
                _a.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchAlertsFailure(errorMsg))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchAlertsEffect.name))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function fetchAlertsEffect(action) {
    var token, language, data, e_11, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 2:
                language = (_a.sent()).language;
                _a.label = 3;
            case 3:
                _a.trys.push([3, 6, , 12]);
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchAlertsService, action.payload, token)];
            case 4:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchAlertsSuccess(data, language))];
            case 5:
                _a.sent();
                return [3 /*break*/, 12];
            case 6:
                e_11 = _a.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_11)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchAlertsFailure(errorMsg))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_11, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchAlertsEffect.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function fetchAlertsFromMobileAppEffect(action) {
    var token, language, data, e_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 2:
                language = (_a.sent()).language;
                _a.label = 3;
            case 3:
                _a.trys.push([3, 6, , 8]);
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchAlertsService, action.payload[0], token, action.payload[1])];
            case 4:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchAlertsSuccess(data, language))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_12 = _a.sent();
                return [4 /*yield*/, catchErrorFetchAlerts(language, e_12)];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function sendMeterReadingEffect(action) {
    var token, data, e_13, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                _a.label = 2;
            case 2:
                _a.trys.push([2, 7, , 14]);
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.sendMeterReadingService, action.payload, token)];
            case 3:
                data = _a.sent();
                if (!action.payload.picture) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.sendMeterReadingPictureService, action.payload.picture, token)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.sendMeterReadingSuccess(data))];
            case 6:
                _a.sent();
                return [3 /*break*/, 14];
            case 7:
                e_13 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_13)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 9:
                _a.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.sendMeterReadingFailure(errorMsg, (0, utils_1.buildTechnicalErrorMessage)(e_13)))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_13, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, sendMeterReadingEffect.name))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function updateResidualLeakStatusEffect(action) {
    var token, e_14, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.updateResidualLeakStatusService, action.payload.sectionSubscriptionId, action.payload.residualLeakServiceStatus, token)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.updateResidualLeakStatusSuccess(action.payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_14 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.updateResidualLeakStatusFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_14, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateResidualLeakStatusEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateOverconsumptionThresholdEffect(action) {
    var token, e_15, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.updateOverconsumptionThresholdService, action.payload.sectionSubscriptionId, action.payload.durationThresholdInDays, action.payload.volumeThresholdInL, token)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.updateOverconsumptionThresholdSuccess(action.payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_15 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.updateOverconsumptionThresholdFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_15, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateOverconsumptionThresholdEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateTranquilityStatusEffect(action) {
    var token, e_16, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.updateTranquilityStatusService, action.payload.sectionSubscriptionId, action.payload.tranquilityServiceStatus, token)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.updateTranquilityStatusSuccess(action.payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_16 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.updateTranquilityStatusFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_16, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateTranquilityStatusEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function fetchRequestTrackingEffect(action) {
    var data, e_17, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.fetchRequestTrackingService, action.payload)];
            case 1:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchRequestTrackingSuccess(data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 7];
            case 3:
                e_17 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.fetchRequestTrackingFailure(errorMsg))];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_17, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchRequestTrackingEffect.name))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function getClientMeterIndexEligibilityEffect(action) {
    var token, responseStatus, e_18, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token) {
                    throw Error('Missing token');
                }
                return [4 /*yield*/, (0, effects_1.call)(deliveryPointService_1.getClientMeterIndexEligibilityService, action.payload.clientId, action.payload.origin, token)];
            case 2:
                responseStatus = _a.sent();
                if (!(responseStatus === 204)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.getClientMeterIndexEligibilitySuccess())];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 8];
            case 5:
                e_18 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.getClientMeterIndexEligibilityFailure(errorMsg))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function deliveryPointEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchDeliveryPoint.type, fetchDeliveryPointEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchCombinedDeliveryPoint.type, fetchCombinedDeliveryPointEffect)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchDeliveryPointsList.type, fetchdeliveryPointsListEffect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchOverConsumptionAlerts.type, fetchOverConsumptionAlertsEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchAlerts.type, fetchAlertsEffect)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchAlertsFromMobileApp.type, fetchAlertsFromMobileAppEffect)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.updateResidualLeakStatus.type, updateResidualLeakStatusEffect)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.updateTranquilityStatus.type, updateTranquilityStatusEffect)];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.updateOverconsumptionThreshold.type, updateOverconsumptionThresholdEffect)];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchLastMeterIndex.type, fetchLastMeterEffect)];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.sendMeterReading.type, sendMeterReadingEffect)];
            case 11:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchMeterInfos.type, fetchMeterInfoEffect)];
            case 12:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.downloadProofDocument.type, downloadProofDocumentEffect)];
            case 13:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.downloadProofDocumentForMobile.type, downloadProofDocumentForMobileEffect)];
            case 14:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeEvery)(deliveryPointState_1.deliveryPointActions.fetchClientWorkOrder.type, fetchClientWorkOrdersEffect)];
            case 15:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchClientWorkOrderV2.type, fetchClientWorkOrdersEffectV2)];
            case 16:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.fetchRequestTracking.type, fetchRequestTrackingEffect)];
            case 17:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(deliveryPointState_1.deliveryPointActions.getClientMeterIndexEligibility.type, getClientMeterIndexEligibilityEffect)];
            case 18:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = deliveryPointEffects;
